<div class="row">
    <div class="col-xl-9 col-md-12">
        <div id="clientList" class="card">
            <ng-container *ngTemplateOutlet="pickList"></ng-container>
        </div>
    </div>
    <div class="col-xl-3 padding-top">
        <ng-container *ngTemplateOutlet="profileView"></ng-container>
    </div>
</div>

<ng-template #profileView>
    <div class="card" id="contact-view-detail">
        <div class="card-body p-3 ">
            <div style="text-align: end;">
                <button *ngIf="securityPermissionClientManagement" [disabled]="(model.id == undefined)"
                    class="btn badge bg-light text-primary fs-12 "
                    (click)="openModalEdit(model.id || 'Not Defined',$event )">
                    <div style="display: inline-flex; padding-top: 2px;">
                        <i class="ri-edit-box-line align-bottom me-1"></i>
                        <div style="text-align: center;" i18n="@@">Edit</div>
                    </div>
                </button>
            </div>
            <div class="text-center">
                <div class="profile-user position-relative d-inline-block mx-auto">
                    <div class="position-relative d-inline-block">
                        <img [src]="profilePhotoPNGTransform(model)" alt=""
                            class="avatar-lg rounded-circle img-thumbnail">
                        <span class="contact-active position-absolute rounded-circle bg-success"></span><span
                            class="visually-hidden"></span>
                    </div>
                    <h5 class="mt-4 mb-1" i18n="@@">{{model.name || "Not Provided"}}</h5>
                </div>
            </div>
        </div>
        <div style="border-bottom: 1px solid #e9ebec ;"></div>

        <div class="card-body">
            <div class="mb-3">
                <h6 class="text-muted text-uppercase fw-semibold mb-3 " i18n="@@">Client Information</h6>
                <div class="table-responsive table-card">
                    <table class="table table-borderless mb-0">
                        <tbody>

                            <tr>
                                <td class="fw-medium gap-2 " scope="row" i18n="@@"><i
                                        class="bg-soft-success text-success rounded bx bx bx-phone"
                                        style="padding: 3px;"></i> Phone No</td>
                                <td class="email" i18n="@@">{{model.phoneNumber || "Not Provided"}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium gap-2 " scope="row" i18n="@@"><i
                                        class="bg-soft-danger text-danger rounded bx bx-mail-send"
                                        style="padding: 3px;"></i> Email </td>
                                <td class="phone" i18n="@@">{{model.email || "Not Provided"}}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
            <ul ngbNav #customNav="ngbNav" [activeId]="1"
                class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0center justify-content-center"
                role="tablist">

                <li [ngbNavItem]="1" class="nav-item">
                    <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                        <i class="far fa-user"></i>
                        Address Information
                    </a>
                    <ng-template ngbNavContent>
                        <table class="table table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Unit</td>
                                    <td class="designation" i18n="@@">{{model.address.unit || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Street</td>
                                    <td class="email" i18n="@@">{{model.address.address1 || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">City</td>
                                    <td class="phone" i18n="@@">{{model.address.city || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Province</td>
                                    <td class="l_score" i18n="@@">{{model.address.province || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Country</td>
                                    <td class="l_score" i18n="@@">{{model.address.country || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Postal Code</td>
                                    <td class="l_score" i18n="@@">{{model.address.postalCode || "Not Provided"}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2" class="nav-item">
                    <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                        <i class="far fa-user"></i>
                        Legal Details
                    </a>
                    <ng-template ngbNavContent>

                        <ul ngbNav #legalNav="ngbNav" [activeId]="1"
                            class="nav nav-tabs-custom  card-header-tabs border-bottom-0center justify-content-center"
                            role="tablist" style="padding-top: 1rem;">

                            <li [ngbNavItem]="1" class="nav-item ">
                                <a ngbNavLink class="nav-link text-body " data-bs-toggle="tab" role="tab">
                                    <i class="far fa-user"></i>
                                    <div i18n="@@">Identification</div>
                                </a>
                                <ng-template ngbNavContent>
                                    <div style="padding: 0.25rem; padding-bottom: 0; margin-top: 0.75rem;">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Driver's License Number
                                                    </td>
                                                    <td i18n="@@">{{model.driverLicense || "Not Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">License Plate </td>
                                                    <td i18n="@@">{{model.licensePlate || "Not Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Health Card Number</td>
                                                    <td i18n="@@">{{model.healthCardNumber || "Not Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">SIN Number</td>
                                                    <td i18n="@@">{{model.sin || "Not Provided"}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="2" class="nav-item">
                                <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                                    <i class="far fa-user"></i>
                                    <div i18n="@@">Insurance</div>
                                </a>
                                <ng-template ngbNavContent>
                                    <div style="padding: 0.25rem; padding-bottom: 0; margin-top: 0.75rem;">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Insurance Company</td>
                                                    <td i18n="@@">{{model.insuranceCompany.name || "Not Provided"}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Policy Holder</td>
                                                    <td i18n="@@">{{model.insuranceCompany.policyHolder || "Not
                                                        Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Claim Number</td>
                                                    <td i18n="@@">{{model.claimNumber|| "Not Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Policy Number</td>
                                                    <td i18n="@@">{{model.insuranceCompany.policyNumber|| "Not
                                                        Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">AB Adjuster</td>
                                                    <td i18n="@@">{{model.abAdjusterName || "Not Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">BI Adjuster</td>
                                                    <td i18n="@@">{{model.biAdjusterName || "Not Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Email</td>
                                                    <td i18n="@@">{{model.insuranceCompany.email || "Not
                                                        Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Phone Number</td>
                                                    <td i18n="@@">{{model.insuranceCompany.phoneNumber || "Not
                                                        Provided"}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </li>
                            <li [ngbNavItem]="3" class="nav-item">
                                <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                                    <i class="far fa-user"></i>
                                    <div i18n="@@">Opposing Counsel</div>
                                </a>
                                <ng-template ngbNavContent>
                                    <div style="padding: 0.25rem; padding-bottom: 0; margin-top: 0.75rem;">
                                        <table class="table table-borderless mb-0">
                                            <tbody>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Name</td>
                                                    <td i18n="@@">{{model.opposingCounsel.name || "Not Provided"}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Phone Number</td>
                                                    <td i18n="@@">{{model.opposingCounsel.phoneNumber || "Not
                                                        Provided"}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="fw-medium" scope="row" i18n="@@">Email</td>
                                                    <td i18n="@@">{{model.opposingCounsel.email || "Not Provided"}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </li>
                        </ul>
                        <div class="tab-model">
                            <div [ngbNavOutlet]="legalNav"></div>
                        </div>
                    </ng-template>
                </li>

                <li [ngbNavItem]="3" class="nav-item">
                    <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                        <i class="far fa-user"></i>
                        <div i18n="@@">Signature</div>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="col-lg-12" style="padding-top: 0.75rem;">
                            <div class="border shadow text-center" style="background-color: #fff;">
                                <img [src]="signaturePNGTransform()"
                                    style="padding: 10px; height:200px; max-width: 100%;" />
                            </div>
                        </div>
                    </ng-template>
                </li>
            </ul>
            <div class="tab-content" style="padding-top: 20px;">
                <div [ngbNavOutlet]="customNav"></div>
            </div>
        </div>
    </div>

</ng-template>
<ng-template #pickList>
    <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems" [listService]="clientListService"
        [sortBy]="sortBy" (buttonActionSelected)="buttonActionSelected($event)"
        (updateCheckedValues)="checkedValGet =  $event" (rowActionSelected)="rowActionSelected($event)"
        (filterSelected)="filterSelected($event)" (sortSelected)="sortByPassedSort($event)"
        (resetListLayout) = "clientListService.resetListState($event)"
        (searchTermChanged)="clientListService.searchTerm = $event"
        (paginationSelected)="paginationUpdated(clientListService,$event)" [serviceData]="serviceData"
        (pageSizeSelected)="clientListService.pageSize = $event"></app-list-layout>
</ng-template>